<template>
  <div>
    <h1 class="header">新增岗位</h1>
    <el-form ref="form" :model="form" label-width="120px">
      <el-form-item
        label="岗位名称"
        prop="name"
        :rules="[
          { required: true, message: '请输入岗位名称', trigger: 'blur' },
          { max: 10, message: '岗位名称不能超过10个字符', trigger: 'change' },
        ]"
      >
        <el-input v-model="form.name" show-word-limit maxlength="10"></el-input>
      </el-form-item>
      <el-form-item
        label="岗位描述"
        prop="description"
        :rules="[
          { required: true, message: '请输入岗位描述', trigger: 'blur' },
          { max: 50, message: '岗位描述不能超过50个字符', trigger: 'change' },
        ]"
      >
        <el-input
          v-model="form.description"
          type="textarea"
          show-word-limit
          maxlength="50"
        ></el-input>
      </el-form-item>
    </el-form>
    <PermissionSelector
      :readonly="false"
      :data="permissions"
      :checkedKeys="checkedKeys"
      @submit="handleSubmit"
      @cancel="handleCancel"
      @reset="handleReset"
    ></PermissionSelector>
  </div>
</template>

<script>
import {
  postGetRoles,
  postGetAllRoles,
  postAddRole,
  postEditRoles,
} from "@/openapi/erp/baobanRoles.js";
import PermissionSelector from "./PermissionSelector.vue";
export default {
  name: "PositionsCreate",
  components: {
    PermissionSelector,
  },
  data() {
    return {
      form: {
        name: "",
        description: "",
        id: "",
        is_official: "",
      },
      tableData: [
        // Add your data here
      ],
      pageMode: "create",
      permissions: [],
      checkedKeys: [],
    };
  },
  created() {
    if (this.$route.name === "PositionCreate") {
      this.pageMode = "create";
      this.getAllPermissionList();
    } else if (this.$route.name === "PositionEdit") {
      this.pageMode = "edit";
      this.getPositionPermissionList();
    }
  },
  methods: {
    getAllPermissionList() {
      postGetAllRoles().then((res) => {
        this.permissions = res.groups;
      });
    },
    handleReset() {
      if (this.pageMode === "create") {
        this.checkedKeys = [];
        this.form = {
          name: "",
          description: "",
        };
        this.$refs.form.resetFields();
      } else if (this.pageMode === "edit") {
        this.getPositionPermissionList();
      }
    },
    handleCancel() {
      const tabPath = this.$route.fullPath.replace("/home", "");
      this.$bus.$emit("removeTab", tabPath);
      this.$router.back();
    },
    handleSubmit(checkedKeys) {
      this.checkedKeys = checkedKeys;
      this.showConfirmModal();
    },
    getPositionPermissionList() {
      let params = {
        role_id: this.$route.params.id,
      };
      postGetRoles(params).then((res) => {
        this.checkedKeys = res.checked_ids;
        this.permissions = res.groups;
        this.form = {
          id: res.role.role_id,
          name: res.role.role_name,
          description: res.role.content,
          is_official: res.role.is_official,
        };
      });
    },
    showConfirmModal() {
      let message =
        this.form.id === "1" ? "是否确认调整，商家开放权限？" : "确认保存吗？";
      this.$confirm(message, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          if (this.pageMode === "create") {
            this.createPosition();
          } else if (this.pageMode === "edit") {
            this.editPosition();
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消保存",
          });
        });
    },
    createPosition() {
      let params = {
        role_name: this.form.name,
        content: this.form.description,
        group_ids: this.checkedKeys.join(","), // 选中的权限
      };
      postAddRole(params).then((res) => {
        this.$message({
          type: "success",
          message: "新增成功",
        });
        const tabPath = this.$route.fullPath.replace("/home", "");
        this.$bus.$emit("removeTab", tabPath);
        this.$router.back();
      });
    },
    editPosition() {
      let params = {
        role_id: this.form.id,
        role_name: this.form.name,
        content: this.form.description,
        group_ids: this.checkedKeys.join(","), // 选中的权限
      };
      postEditRoles(params).then((res) => {
        this.$message({
          type: "success",
          message: "修改成功",
        });
        const tabPath = this.$route.fullPath.replace("/home", "");
        this.$bus.$emit("removeTab", tabPath);
        this.$router.back();
      });
    },
  },
};
</script>

<style lang="less" scoped>
.button-group {
  margin-top: 20px;
  display: flex;
  justify-content: flex-start;
}

.header {
  margin-bottom: 16px;
}
</style>



// WEBPACK FOOTER //
// src/pages/positionPermissions/PositionsCreate.vue